import {
    FETCH_SUBMISSIONS_REQUEST,
    FETCH_SUBMISSIONS_SUCCESS,
    FETCH_SUBMISSIONS_FAILURE,
    APPEND_SUBMISSIONS_REQUEST,
    APPEND_SUBMISSIONS_SUCCESS,
    APPEND_SUBMISSIONS_FAILURE,
    FETCH_SUBMISSION_REQUEST,
    FETCH_SUBMISSION_SUCCESS,
    FETCH_SUBMISSION_FAILURE,
    CREATE_SUBMISSION_REQUEST,
    CREATE_SUBMISSION_SUCCESS,
    CREATE_SUBMISSION_FAILURE,
    UPDATE_SUBMISSION_REQUEST,
    UPDATE_SUBMISSION_SUCCESS,
    UPDATE_SUBMISSION_FAILURE,
    DELETE_SUBMISSION_REQUEST,
    DELETE_SUBMISSION_SUCCESS,
    DELETE_SUBMISSION_FAILURE,
    CLEAR_SUBMISSION,
    CLEAR_SUBMISSION_ERRORS,
    REMOVE_SUBMISSION_FROM_LIST
  } from '../actions/submissionActions';

  const initialState = {
    submissions: null,
    submission: null,
    loading: false,
    loadingMore: false,
    hasMore: false,
    error: null
  };
  
  // Reducer
  const submissionReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SUBMISSIONS_REQUEST:
      case FETCH_SUBMISSION_REQUEST:
      case CREATE_SUBMISSION_REQUEST:
      case UPDATE_SUBMISSION_REQUEST:
      case DELETE_SUBMISSION_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_SUBMISSIONS_SUCCESS:
        return {
          ...state,
          submissions: action.payload,
          loading: false,
          hasMore: action.payload.pagination.page < action.payload.pagination.pages,
          error: null
        };

      case APPEND_SUBMISSIONS_REQUEST:
        return { ...state, loadingMore: true, error: null };

      case APPEND_SUBMISSIONS_SUCCESS:
        return {
          ...state,
          submissions: {
            ...action.payload,
            items: [...(state.submissions?.items || []), ...action.payload.items]
          },
          loadingMore: false,
          hasMore: action.payload.pagination.page < action.payload.pagination.pages,
          error: null
        };

      case APPEND_SUBMISSIONS_FAILURE:
        return { ...state, loadingMore: false, error: action.payload };
      
      case FETCH_SUBMISSION_SUCCESS:
        return {
          ...state,
          submission: action.payload,
          loading: false,
          error: null
        };
      
      case CREATE_SUBMISSION_SUCCESS:
        return {
          ...state,
          submissions: state.submissions ? {
            ...state.submissions,
            items: [action.payload, ...(state.submissions.items || [])]
          } : state.submissions,
          submission: action.payload,
          loading: false,
          error: null
        };
      
      case UPDATE_SUBMISSION_SUCCESS:
        return {
          ...state,
          submissions: state.submissions ? {
            ...state.submissions,
            items: state.submissions.items?.map(submission =>
              submission.id === action.payload.id ? action.payload : submission
            )
          } : state.submissions,
          submission: action.payload,
          loading: false,
          error: null
        };
      
      case DELETE_SUBMISSION_SUCCESS:
        return {
          ...state,
          submissions: state.submissions ? {
            ...state.submissions,
            items: state.submissions.items?.filter(submission => 
              submission.id !== action.payload
            )
          } : state.submissions,
          submission: state.submission?.id === action.payload ? null : state.submission,
          loading: false,
          error: null
        };
      
      case FETCH_SUBMISSIONS_FAILURE:
      case FETCH_SUBMISSION_FAILURE:
      case CREATE_SUBMISSION_FAILURE:
      case UPDATE_SUBMISSION_FAILURE:
      case DELETE_SUBMISSION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      case CLEAR_SUBMISSION:
        return {
          ...state,
          submission: null,
          error: null
        }; 
      case CLEAR_SUBMISSION_ERRORS:
        return {
          ...state,
          error: null
        };

      case REMOVE_SUBMISSION_FROM_LIST:
        return {
          ...state,
          submissions: state.submissions ? {
            ...state.submissions,
            items: state.submissions.items?.filter(s => s.id !== action.payload)
          } : state.submissions
        };

      default:
        return state;
    }
  };
  
  export default submissionReducer;